// src/reducers/enrollments_reducer.js
import { RECEIVE_MY_ENROLLMENTS, UPDATE_ENROLLMENT } from "../actions/enrollment_actions";

const initialState = {
  byId: {},
  byCourseKey: {}, // { 'ombre_powder_brows': enrollmentId }
  allIds: [],
};

const getCourseKey = (enr) =>
  (enr?.course && (enr.course.key || enr.course.courseKey)) ||
  enr?.courseKey ||
  enr?.key ||
  "";

const enrollmentsReducer = (state = initialState, action) => {
  Object.freeze(state);

  switch (action.type) {
    case RECEIVE_MY_ENROLLMENTS: {
      const byId = {};
      const byCourseKey = {};
      const allIds = [];

      (action.enrollments || []).forEach((enr) => {
        if (!enr || !enr._id) return;
        const id = enr._id;

        byId[id] = enr;
        allIds.push(id);

        const key = getCourseKey(enr);
        if (key) byCourseKey[key] = id;
      });

      return { ...state, byId, byCourseKey, allIds };
    }

    case UPDATE_ENROLLMENT: {
      const enr = action.enrollment;
      if (!enr || !enr._id) return state;

      const id = enr._id;

      const nextById = { ...state.byId, [id]: enr };

      const nextByCourseKey = { ...state.byCourseKey };
      const key = getCourseKey(enr);
      if (key) nextByCourseKey[key] = id;

      const nextAllIds = state.allIds.includes(id) ? state.allIds : [...state.allIds, id];

      return {
        ...state,
        byId: nextById,
        byCourseKey: nextByCourseKey,
        allIds: nextAllIds,
      };
    }

    default:
      return state;
  }
};

export default enrollmentsReducer;
